if ($('.id--16').length) {
    $("#cart_contact").insertBefore(".sidebar.sidebar-left > a");
 } else if ($('.id--17').length) {
    $("#cart_contact").insertBefore(".sidebar.sidebar-left > a");
 } else {
     $("#cart_contact").hide();
 }